import { Clickable, Col, Icon, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, OrderPanel } from 'screens/Admin/components';
import { Filters, List } from './components';

const Orders = ({}) => {
  const [dataId, setDataId] = useState(null),
    [owner, setOwner] = useState(null),
    [loading, setLoading] = useState(false),
    orders = useSelector((state) => state.admin.orders),
    fetching = useRef(false),
    skip = useRef(0),
    dispatch = useDispatch(),
    scrollId = 'admin-orders-list';

  useEffect(() => {
    skip.current = orders?.length || 0;
  }, [orders]);

  useEffect(() => {
    skip.current = 0;
    setLoading(true);

    getOrders(true);
  }, [owner]);

  useInfiniteScroll(scrollId, getOrders);

  async function getOrders(isInitial) {
    if (fetching.current) return;
    fetching.current = true;

    const res = await Api.post('/admin/getOrders', {
      skip: skip.current || 0,
      ownerId: owner?._id
    });

    console.log(res);

    if (!res) return (fetching.current = false);

    dispatch({
      type: owner || isInitial ? 'ADMIN_SET_ORDERS' : 'ADMIN_ADD_ORDERS',
      payload: res
    });

    fetching.current = false;
    setLoading(false);
  }

  function handleSelect(postId) {
    setDataId(postId);
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Orders</Text>

          <Clickable onClick={() => setDataId(true)}>
            <Icon marg="0 0 0 8px" type="add" dimensions={18} />
          </Clickable>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters owner={owner} setOwner={setOwner} className="filters" />

        <List data={orders} dataId={dataId} onClick={handleSelect} loading={loading} />
      </Col>

      <OrderPanel dataId={dataId} setDataId={setDataId} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Orders;
